// extracted by mini-css-extract-plugin
module.exports = {"input":"_base-input_input_1vKTx"};